import { Controller } from "stimulus"
import { fetchJSON } from "../lib/fetch_json"

export default class extends Controller {
  static targets = ["field", "saveIndicator", "saveButton", "errorList"]
  static values = { saveUrl: String, debounceMs: Number }

  connect() {
    if (!this.hasDebounceMsValue) this.debounceMsValue = 800
    this._saveTimeout = null
    this._dirty = false
  }

  disconnect() {
    clearTimeout(this._saveTimeout)
  }

  onFieldChange() {
    this._dirty = true
    this.showSaveState("dirty")
    this.debouncedSave()
  }

  saveNow() {
    clearTimeout(this._saveTimeout)
    this.triggerSave()
  }

  debouncedSave() {
    clearTimeout(this._saveTimeout)
    this._saveTimeout = setTimeout(() => this.triggerSave(), this.debounceMsValue)
  }

  async triggerSave() {
    if (!this._dirty) return

    this.showSaveState("saving")
    const payload = this.collectFields()

    try {
      const data = await fetchJSON(this.saveUrlValue, {
        method: "PATCH",
        body: { opportunity: payload }
      })

      if (data.errors) {
        this.showSaveState("error", data.errors)
      } else {
        this._dirty = false
        this.showSaveState("saved")
        this.clearErrors()
        document.dispatchEvent(new CustomEvent("opp-editor:saved", {
          detail: { section: "additional", completion: data.completion }
        }))
      }
    } catch (e) {
      this.showSaveState("error", [e.message])
    }
  }

  collectFields() {
    const payload = {}
    this.fieldTargets.forEach(field => {
      const name = field.dataset.fieldName
      if (!name) return
      if (field.type === "checkbox") {
        payload[name] = field.checked
      } else {
        payload[name] = field.value
      }
    })
    return payload
  }

  showSaveState(state, errors = null) {
    if (!this.hasSaveIndicatorTarget) return
    const indicator = this.saveIndicatorTarget
    indicator.classList.remove("d-none")

    switch (state) {
      case "dirty":
        indicator.innerHTML = '<span class="text-muted"><i class="fas fa-pencil-alt fa-sm me-1"></i>Unsaved</span>'
        break
      case "saving":
        indicator.innerHTML = '<span class="text-info"><i class="fas fa-spinner fa-spin fa-sm me-1"></i>Saving...</span>'
        break
      case "saved":
        indicator.innerHTML = '<span class="text-success"><i class="fas fa-check fa-sm me-1"></i>Saved</span>'
        setTimeout(() => {
          if (!this._dirty) indicator.classList.add("d-none")
        }, 3000)
        break
      case "error":
        indicator.innerHTML = '<span class="text-danger"><i class="fas fa-exclamation-circle fa-sm me-1"></i>Error</span>'
        if (errors && this.hasErrorListTarget) {
          this.errorListTarget.innerHTML = errors.map(e => `<li>${e}</li>`).join("")
          this.errorListTarget.classList.remove("d-none")
        }
        break
    }
  }

  clearErrors() {
    if (this.hasErrorListTarget) {
      this.errorListTarget.innerHTML = ""
      this.errorListTarget.classList.add("d-none")
    }
  }
}
